import React from 'react'

import { Href } from 'components/_new/controls'
import { Box } from 'components/_new/layout'
import ProductImage from 'components/_new/ui/ProductImage/ProductImage'
import ProductCardHeadline from 'components/_new/product/ProductCardHeadline/ProductCardHeadline'

import s from './ProductCard.scss'


type ProductCardProps = {
  image: string
  url: string
  name: string
  brand: string
}

const ProductCard: React.FunctionComponent<ProductCardProps> = ({ image, url, name, brand }) => (
  <Href to={url} className={s.root}>
    <ProductImage
      className={s.image}
      src={image}
      height={96}
      resizeBy="width"
      alt={`${brand} ${name}`}
    />
    <Box mt={16}>
      <ProductCardHeadline
        brand={brand}
        name={name}
      />
    </Box>
  </Href>
)


export default ProductCard
